import React, { useEffect } from "react";
import InvoicePayment from "../../../components/Invoices/InvoicePayment";
import { loadingsShow } from "../../../Services/PostAPI";
import invoicePaymentData from "./tableData.json";
import { useHistory } from "react-router-dom";
import { APP_URLS } from "../../../constants/urlConstants";
import { connect } from "react-redux";
import {
  fetchInvoicePaymentList,
  initializeInvoicePaymentScreen,
} from "../../../Redux/Actions/invoice";
import { ProgressBar } from "primereact/progressbar";

const InvoicePaymentScreen = (props) => {
  const {
    initializeInvoicePaymentScreen,
    fetchInvoicePaymentList,
    paginationInfo,
    invoicePaymentList,
    showPageLevelLoader,
    isLoading,
  } = props;

  const history = useHistory();

  useEffect(() => {
    initializeInvoicePaymentScreen();
    fetchInvoicePaymentList();
  }, []);

  const loadLazyData = (props) => {
    fetchInvoicePaymentList(props);
  };

  const navigateToInvoicesScreen = () => {
    history.push(APP_URLS.INVOICES.HOME);
  };

  const invoicePaymentProps = {
    ...invoicePaymentData,
    navigateToInvoicesScreen,
    fetchInvoicePaymentLists: loadLazyData,
    tableData: {
      ...invoicePaymentData.tableData,
      rows: invoicePaymentList,
    },
    isLoading,
    paginationInfo: {
      ...invoicePaymentData.paginationInfo,
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.total_elements,
    },
  };

  const renderProgressBar = () => {
    return <ProgressBar mode="indeterminate" style={{ height: "6px" }} />;
  };

  if (showPageLevelLoader) {
    loadingsShow("block");
    return null;
  }
  loadingsShow("none");
  return (
    <>
      {isLoading && renderProgressBar()}
      <InvoicePayment {...invoicePaymentProps} />
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    initializeInvoicePaymentScreen: () =>
      dispatch(initializeInvoicePaymentScreen()),
    fetchInvoicePaymentList: (payload) =>
      dispatch(fetchInvoicePaymentList(payload)),
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    isLoading: selectFromInvoicesReducer(state, "isLoading"),
    invoicePaymentList: selectInvoicePaymentList(state.invoiceReducer),
    showPageLevelLoader: selectIsLoadingPage(state.invoiceReducer),
    paginationInfo: selectPaginationInfo(state.invoiceReducer),
    isPageLevelError: selectIsPageLevelError(state.invoiceReducer),
    isFetchingGridData: selectIsLoading(state.invoiceReducer),
  };
};

const selectInvoicePaymentList = (invoiceReducer) =>
  invoiceReducer.invoicePaymentList;
const selectPaginationInfo = (invoiceReducer) => invoiceReducer.paginationInfo;
const selectIsLoadingPage = (invoiceReducer) => invoiceReducer.isLoadingPage;
const selectIsPageLevelError = (invoiceReducer) =>
  invoiceReducer.isPageLevelError;
const selectIsLoading = (invoiceReducer) => invoiceReducer.isLoading;

const selectFromInvoicesReducer = (state, path) => {
  return selectInvoicesReducer(state)[path];
};

const selectInvoicesReducer = ({ invoiceReducer }) => {
  return invoiceReducer;
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InvoicePaymentScreen);
